import axios from "axios";

export function getOrders(page = 1, limit) {
    return axios.get(`factor/factors?page=${page}&limit=${limit}`);
}

export function getStatuses() {
    return axios.get(`order/status`);
}

export function getFactors() {
    return axios.get(`factor/factors/pending`);
}

export function getFactorItems(factor_id) {
    return axios.get(`factor/items/${factor_id}`);
}

export function createFactor(data) {
    return axios.post(`factor/create`, data);
}


export function updateStatus(data) {
    return axios.post(`order/status/update`, data);
}

export function updateFactorStatus(data) {
    return axios.post(`factor/status/update`, data);
}